import Colors from 'components/Colors.js';

const colors = new Colors();

export default superclass => class extends superclass {
    color = '#ffffff';

    initColor() {
        this.color = colors.getColorForHash(this.id);
    }
}
